module.exports = __webpack_public_path__ + "img/Name.9b90345e.svg";